define("ember-svg-jar/inlined/lib-twitter", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _default = _exports.default = {
    "content": "<path d=\"M16.093 12.316L24.283 3h-1.94l-7.112 8.088L9.55 3H3l8.589 12.231L3 25h1.94l7.51-8.542L18.45 25H25l-8.907-12.684zm-2.658 3.023l-.87-1.218L5.64 4.43h2.981l5.588 7.82.87 1.219 7.264 10.166h-2.98l-5.928-8.296z\" fill=\"currentColor\"/>",
    "attrs": {
      "width": "28",
      "height": "28",
      "viewBox": "0 0 28 28",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  };
});